import React from "react";
import SectionWrapper from "components/layout/section_wrapper";
import DummyImage from "assets/images/dummy-image-square.jpg";
import { Col, Row } from "react-bootstrap";
import styles from "./sister_property_section.module.css";
import { CloseCircleOutlined } from "@ant-design/icons";
import buildPath from "utils/build_path";
import { useHistory } from "react-router-dom";
import routes from "routing/routes";

export default function SisterPropertSection({ sisterProperties = [], setShowSisterProperties }) {
  const history = useHistory();
  return (
    <div>
      <SectionWrapper id="hotel_rates_section" theme="dark">
        <Col>
          <div
            className="d-flex justify-content-between align-items-center"
            onClick={() => setShowSisterProperties(false)}
          >
            <p>Consider our nearby sister hotels.</p>
            <CloseCircleOutlined style={{ fontSize: 20, cursor: "pointer" }} />
          </div>

          <Row className="px-4 mb-4" style={{ maxHeight: 160, overflowY: "scroll" }}>
            {sisterProperties?.map((sp, index) => (
              <Col lg={"4"} key={index} md="4" sm="4" xs="12">
                <div
                  onClick={() => {
                    const path = buildPath(history.location.search, routes.hotelPage, {
                      channelId: sp?.channel_id,
                    });
                    // history.push(path);
                    window.location.href = path;
                  }}
                  className={styles.sisterContainer}
                >
                  <img
                    className={styles.sisterImage}
                    src={sp?.image || DummyImage}
                    alt="hotel_image"
                  />
                  <p className="px-2">{sp?.hotel_name}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </SectionWrapper>
    </div>
  );
}
